import { Injectable } from '@angular/core';
import { ICreateFlexTimeCorrectionRequest, IFlexTimeCorrection, ISearchFlexTimeCorrectionsRequest } from '../models/flex-time-correction';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';
import { IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FlexTimeCorrectionService {

  constructor(private http: HttpClient) { }

  searchflextimecorrections(request: ISearchFlexTimeCorrectionsRequest){
    return this.http.post<IPagedResults<IFlexTimeCorrection[]>>(
      `${environment.baseUrl}/v1/flextimecorrection/searchflextimecorrections`,
      request
    )
  }

  createflextimecorrection(request: ICreateFlexTimeCorrectionRequest){
    return this.http.post<string>(
      `${environment.baseUrl}/v1/flextimecorrection/createflextimecorrection`,
      request
    )
  }

  deleteflextimecorrection(id: string){
    return this.http.delete<string>(
      `${environment.baseUrl}/v1/flextimecorrection/deleteflextimecorrection/${id}`
    )
  }
}
